const ResidentDashboard = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>Resident Dashboard</h1>
      <p>Welcome. Features coming soon.</p>
    </div>
  );
};

export default ResidentDashboard;